import "@theme/front/init.scss";

import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";

import "@mdi/font/css/materialdesignicons.min.css";

import {initMap} from "./front/map";
window.initMap = initMap;

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	const s = document.createElement("script");
	s.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyCqCWwkCMMmYSottP5qApqoY1I2QMIc8sU&callback=initMap");
	document.body.appendChild(s);
});
